import React from 'react'

import Icon from '../Icon/Icon'
import styles from './TransactionIcon.module.scss'

const TransactionIcon = ({ name }: { name: string }) => {
  return (
    <div className={styles.transaction}>
      <Icon name={name} />
    </div>
  )
}

export default TransactionIcon
